import {concatUrl} from "@/service/base";
import {appDownloadRequest, appRequest, request} from "@/service/request";
import {EventId as eventId} from '@/util/constants'

/**
 * 用户登录
 * @param name
 * @param password
 * @returns {Promise<*>}
 */
export async function userLogin(name, password) {
  return await appRequest(concatUrl("/user/login"), {
    method: "POST",
    body: JSON.stringify({username: name, password}),
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
  });
}

//6、客户问卷结果页面查询 /user/clientQuery
export async function resultQuery(params) {
  return await appRequest(concatUrl("/user/resultQueryByPage"), {
    method: "POST",
    body: JSON.stringify({...params, eventId}),
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
  });
}

//客户问卷修改过程页面查询 /user/clientHistory
export async function clientHistoryQuery(clientId) {
  return await appRequest(concatUrl("/user/clientHistory"), {
    method: "POST",
    body: JSON.stringify({clientId, eventId}),
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
  });
}

///user/resultExport
export async function resultExport(name) {
  return await appDownloadRequest(concatUrl("/user/resultExport"), {
    method: "POST",
    body: JSON.stringify({name, eventId}),
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
  });
}

//4、客户白名单页面查询 /user/clientQuery
export async function queryClientList({name, offset, pageSize,...otherParmas}) {
  return await appRequest(concatUrl("/user/clientQueryByPage"), {
    method: "POST",
    body: JSON.stringify({name, offset, pageSize,...otherParmas, eventId}),
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
  });
}


/**
 * 客户白名单新增、修改、删除（单个编辑）/user/clientOperation
 *   // event_id  int  是  事件ID
 // operation  string  是  操作类型：1-新增，2-修改，3-删除
 // client_id  int  否  客户ID
 // name  string  否  客户姓名，新增修改时必填
 // phone  string  否  客户手机号
 // channel  string  否  渠道，新增修改时必填
 // channel_manager  string  否  渠道经理，新增修改时必填
 * @param operation
 * @param clientId
 * @param name
 * @param phone
 * @param channel
 * @param channelManager
 * @returns {Promise<*>}
 */
export async function addOrUpdateOrDeleteClient(params) {

  return await appRequest(concatUrl("/user/clientOperation"), {
    method: "POST",
    body: JSON.stringify({...params, eventId}),
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
  });
}

//白名单 批量导入 /user/clientImport
export async function importClient(file) {
  const body = new FormData();
  body.append("eventId", eventId);
  body.append("file", file);
  return await appRequest(concatUrl("/user/clientImport"), {
    method: "POST",
    body: body,
    headers: {
      // 'Content-Type': 'multipart/form-data'
    },
  });
}

//获取微信密匙
export async function getSignPackage(params) {
  return await appRequest(concatUrl("/wechat/info"), {
    method: "POST",
    body: JSON.stringify(params),
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
  });
}

// 获取渠道
export async function getQueryChannel() {
  const body = new FormData();
  body.append("eventId", eventId);
  return await appRequest(concatUrl("/user/queryChannel"), {
    method: "POST",
    body: body,
    headers: { },
  });
}

// 获取渠道经理
export async function getQueryChannelManager() {
  const body = new FormData();
  body.append("eventId", eventId);
  return await appRequest(concatUrl("/user/queryChannelManager"), {
    method: "POST",
    body: body,
    headers: { },
  });
}

// 议程图片上传
export async function uploadMeetingPicture(file) {
  const body = new FormData();
  body.append("eventId", eventId);
  body.append("file", file);
  return await appRequest(concatUrl("/user/uploadMeetingPicture"), {
    method: "POST",
    body: body,
    headers: {
      // 'Content-Type': 'multipart/form-data'
    },
  });
}

// 获取议程图片
export async function queryMettingPicture() {
  const body = new FormData();
  body.append("eventId", eventId);
  return await appRequest(concatUrl("/user/queryMeetingPicture"), {
    method: "POST",
    body: body,
    headers: { },
  });
}

// 发送问卷记录
export async function sendResultEmail(params) {
  return await appRequest(concatUrl("/user/sendResultEmail"), {
    method: "POST",
    body: JSON.stringify(params),
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
  });
}

// 发送邀请邮件
export async function sendInviteEmail(params) {
  return await appRequest(concatUrl("/user/sendInviteEmail"), {
    method: "POST",
    body: JSON.stringify(params),
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
  });
}

// 邮件记录
export async function queryEmailRecord(params) {
  return await appRequest(concatUrl("/user/queryEmailRecord "), {
    method: "POST",
    body: JSON.stringify(params),
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
  });
}

// 数据汇总
export async function summary(params) {
  const body = new FormData();
  body.append("eventId", eventId);
  return await appRequest(concatUrl("/user/summary "), {
    method: "POST",
    body,
    headers: {
    },
  });
}

export async function userOperateResult(data) {
  return await appRequest(concatUrl('/user/operateResult'), {
    method: 'POST',
    body: JSON.stringify({eventId, ...data}),
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    }
  })
}